import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import {
  createStore,
  applyMiddleware,
  compose,
  Dispatch,
  Action,
}                                                     from 'redux';
import { persistStore, persistReducer }               from 'redux-persist';
import storage                                        from 'redux-persist/lib/storage';
import { createBrowserHistory }                       from 'history';
import { createLogger }                               from 'redux-logger';
import { rootReducer }                                from './rootReducer';

const persistConfig = {
  key       : 'root',
  storage,
  version   : 1,
  blacklist : ['router'],
};

const composeEnhancers = (process.env.NODE_ENV === 'development'
  && window
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) /* eslint-disable-line no-underscore-dangle */
    || compose;

export const browserHistory: any = createBrowserHistory();
export const routerMiddleware    = createRouterMiddleware(browserHistory);
const persistedReducer           = persistReducer(persistConfig, rootReducer(browserHistory));
const logger                     = createLogger({
  collapsed: (getState, action, logEntry) => !logEntry?.error,
});

interface IStore {
  dispatch: Dispatch<Action<any>>;
  getState: () => any;
}

interface IConfigureStore {
  createdStore : IStore;
  persistor    : any;
}

function configureStore(initialState?: any): IConfigureStore {
  // configure middlewares
  const middlewares = [routerMiddleware];

  // redux-logger
  if (process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
  }

  // compose enhancers
  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  // create store
  const createdStore = createStore(persistedReducer, initialState, enhancer);

  // persist store
  const persistor = persistStore(createdStore);

  return { createdStore, persistor };
}

// pass an optional param to rehydrate state on app start
export const store = configureStore();

// export store singleton instance
export default store; // eslint-disable-line import/no-default-export
